import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { RenderInAppToolbarDirective } from 'app-shell-ui';
import { AuthenticationService, AuthenticationStore } from 'authentication-data';

@Component({
  selector: 'ideal-login-timeout-screen',
  imports: [RenderInAppToolbarDirective, MatCardModule, MatButtonModule],
  templateUrl: './login-timeout-screen.component.html',
  styleUrl: './login-timeout-screen.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginTimeoutScreenComponent {
  private readonly _authService = inject(AuthenticationService);
  private readonly _store = inject(AuthenticationStore);

  protected showScreen = this._store.showLoginTimeoutScreen;
  protected options = this._store.loginTimeoutScreenOptions;

  protected login() {
    this._authService.signIn();
  }
  protected continue() {
    // Logic to handle continue
    location.reload();
  }
}
